export enum EmailToSmsRoutes {
  root = 'settings/email-to-sms',
}
